import React from 'react'
import { useValue } from '@morningtrain/react-resources'

export default function NormItemRowAnchorId () {
  const inventoryItemId = useValue('id')

  return (
    <div id={`item-row-${inventoryItemId}`} />
  )
}
